import { t } from '@lingui/core/macro';
import type { OrganizationForCarRecord } from '@navio/nsdk';
import { cn, NoddiIcon } from 'noddi-ui-common';
import { NoddiBasicCard, NoddiCard } from 'noddi-ui-web';
import type { SelectedOrganization } from '../../../../types/stationaryBooking';

type Props = {
  organizations: OrganizationForCarRecord[];
  selectedOrganization: SelectedOrganization | null;
  onSelect: (organization: OrganizationForCarRecord) => void;
};

export const OrganizationPicker = ({ organizations, selectedOrganization, onSelect }: Props) => {
  return (
    <NoddiCard
      title={t`Select organization`}
      description={t`This car belongs to multiple organizations. Please select which one should be used for this booking.`}
    >
      <div className='flex flex-col gap-2'>
        {organizations.map((org) => {
          const isSelected = selectedOrganization?.organizationId === org.organizationId;
          return (
            <NoddiBasicCard
              key={org.organizationId}
              size='small'
              className={cn(
                'flex items-center justify-between gap-4 border-2 transition-colors',
                isSelected ? 'border-primary' : 'border-transparent'
              )}
              onClick={() => onSelect(org)}
            >
              <div className='flex items-center gap-2'>
                <NoddiIcon name='Building2' size='small' />
                <span className='text-sm font-medium'>{org.organizationName}</span>
              </div>
              {isSelected && <NoddiIcon name='Check' size='small' className='text-primary' />}
            </NoddiBasicCard>
          );
        })}
      </div>
    </NoddiCard>
  );
};
